export default "__VITE_ASSET__CkIWKiay__"